import { useGetOne } from 'react-admin';

export const useGetAppConfig = () => {
  const { data: remoteAppConfig, refetch: refetchAppConfig } =
    useGetOne('therapistAppConfig', {
      id: 'current',
      meta: {
        raw: true,
      },
    });

  return {
    remoteAppConfig,
    refetchAppConfig,
  };
};
